module.exports = __webpack_public_path__ + "static/media/13_tn.ca3eecf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/13_tn.jpg
// module id = 503
// module chunks = 0